import React from 'react'
import './SkinAssessmentQuestionFooter.scss'
import SkinAssessmentButton from '../../../../../common/skinAssessmentButton/SkinAssessmentButton'

const SkinAssessmentQuestionFooter = ({ handleSubmit = () => { }, handleBack = () => { }, buttonActive = false, backBtnText = 'ย้อนกลับ', nextBtnText = 'ถัดไป' }) => {

    return (
        <div className="skin-assessment-footer-vector">
            <img src={`/images/skin-assessment/question-footer.svg`} className="w-100 footer-curve-bg" />
            <div className="footer-btn-parent">
                <SkinAssessmentButton onBtnClick={handleBack} btnClassName='footer-btn-back'>{backBtnText}</SkinAssessmentButton>
                <SkinAssessmentButton onBtnClick={handleSubmit} disabled={!buttonActive} btnClassName={`footer-btn-submit${!buttonActive ? ' footer-btn-disable' : ''}`}>{nextBtnText}</SkinAssessmentButton>
            </div>
        </div>
    )
}

export default SkinAssessmentQuestionFooter
